<template>
  <div v-if="isLoaded">
    <h4 v-if="showMortgageInformation && typeof mortgageProperty.mortgage !== 'undefined'">Onderpand voor hypotheek:
      {{ mortgageProperty.mortgage.data.hypotheeknummer }}</h4>
    <a-form :form="form" layout="vertical" style="margin-bottom: 15px;" @submit="handleSubmit">
      <a-row :gutter="16">
        <a-col :span="12">
          <div class="ant-col ant-form-item-label"><label title="Is nieuwbouw">Gebruiken voor waardeberekeningen</label>
          </div>
          <a-radio-group
              v-model="mortgageProperty.ltv_calculation"
              button-style="solid"
              v-on:change="handleLTVChange">
            <a-radio-button :value="true">
              Ja
            </a-radio-button>
            <a-radio-button :value="false">
              Nee
            </a-radio-button>
          </a-radio-group>
        </a-col>
        <a-col :span="12">
          <div class="ant-col ant-form-item-label"><label title="Is nieuwbouw">Is nieuwbouw</label></div>
          <a-radio-group
              v-model="isNew"
              button-style="solid"
              v-on:change="handleIsNewChange($event.target.value)">
            <a-radio-button :value="true">
              Ja
            </a-radio-button>
            <a-radio-button :value="false">
              Nee
            </a-radio-button>
          </a-radio-group>
        </a-col>
        <a-col v-if="isNew" :span="12">
          <div class="ant-col ant-form-item-label"><label title="Soort nieuwbouw">Soort nieuwbouw</label></div>
          <a-select
              v-model="mortgageProperty.new_construction_type"
              v-on:change="handleConstructionTypeChange"
          >
            <a-select-option v-for="(newConstructionTypeName, newConstructionType) in newConstructionTypes"
                             :key="newConstructionType"
                             :value="newConstructionType">
              {{ newConstructionTypeName }}
            </a-select-option>
          </a-select>
        </a-col>
      </a-row>
    </a-form>
    <PropertyShowComponent v-if="showProperty" :propertyObject="mortgageProperty.property.data"/>
  </div>
</template>

<script>
import propertyApi from "~/api/property"
import mortgagePropertyApi from "~/api/mortgage_property"
import PropertyShowComponent from "~/modules/property/components/ShowComponent"

export default {
  name: "MortgagePropertyEditComponent",
  components: {
    PropertyShowComponent
  },
  props: {
    mortgagePropertyObject: {
      type: Object,
      required: false,
      default: null
    },
    mortgagePropertyId: {
      type: [Number, String],
      required: false,
      default: null
    },
    showProperty: {
      type: Boolean,
      required: false,
      default: true
    },
    showMortgageInformation: {
      type: Boolean,
      required: false,
      default: false
    },
    property: {
      type: Object,
      required: false,
      default: undefined
    },
  },
  data() {
    return {
      isNewProxy: null,
      isLoaded: false,
      mortgageProperty: {},
      newConstructionTypes: {
        '': 'Onbekend',
        collective_private_commissioning: 'CPO',
        diy: 'Zelfbouw',
        project_construction: 'Projectbouw',
      },
      formLayout: 'horizontal',
      form: this.$form.createForm(this, {name: 'coordinated'}),

    };
  },
  mounted() {
    if (this.mortgagePropertyObject !== null) {
      this.mortgageProperty = this.mortgagePropertyObject
      this.isNew = this.mortgageProperty.property.data.collateral_type === 'new';
      this.isLoaded = true;
    } else if (this.mortgagePropertyId !== null) {
      mortgagePropertyApi.findById(this.mortgagePropertyId, ['property', 'mortgage']).then(response => {
        this.mortgageProperty = response.data;
        this.isNew = this.mortgageProperty.property.data.collateral_type === 'new';
        this.isLoaded = true;
      })
    } else {
      this.$message.error('Er ging iets mis tijdens het inladen van een onderpand');
    }
  },
  computed: {
    isNew: {
      get() {
        if (this.property && typeof this.property !== 'undefined' && this.property.data.collateral_type !== this.isNewProxy) {
          this.isNew = this.property.data.collateral_type === "new";
        }
        return this.isNewProxy
      },
      set(val) {
        this.isNewProxy = val;
      }
    },
  },
  methods: {
    handleSubmit() {
    },
    handleIsNewChange(value) {
      this.mortgageProperty.property.data.collateral_type = value ? 'new' : null;
      propertyApi.update(this.mortgageProperty.property.data).then(response => {
        this.$emit('property-updated', this.mortgageProperty.property)
      });

    },
    handleConstructionTypeChange() {
      mortgagePropertyApi.update(this.mortgageProperty);
    },
    handleLTVChange() {
      mortgagePropertyApi.update(this.mortgageProperty);
    }
  },
}
</script>
<style scoped>
.search-component {
  position: relative;
}

.search-component .results {
  position: absolute;
  width: calc(100% - 10px);
  background: rgba(255, 255, 255, 0.91);
  margin: 5px;
  max-height: 300px;
  overflow: auto;
}
</style>
